var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aplayer',{attrs:{"list":_vm.musics,"music":_vm.musics[0],"show-lrc":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }